<template>
  <div>
    <div v-if="loading">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      
      <div class="col-md-9">
        <form-base
        class="py-5"
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Name" :required="true">
              <input
                type="text"
                @blur="$v.organisation.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.organisation.name.$error }"
                v-model="organisation.name"
              />

              <div class="invalid-feedback" v-if="!$v.organisation.name.required">
                Please enter name
              </div>
            </form-group>

            <form-group label="Code">
              <input
                type="text"
                class="form-control"
                v-model="organisation.code"
              />
            </form-group>

            <form-group label="Registration Number">
              <input
                type="text"
                class="form-control"
                v-model="organisation.registration_number"
              />
            </form-group>

            <form-group label="Contact Number">
              <input
                type="text"
                class="form-control"
                v-model="organisation.contact_number"
              />
            </form-group>

            <form-group label="Contact Number 2">
              <input
                type="text"
                class="form-control"
                v-model="organisation.contact_number_2"
              />
            </form-group>

            <form-group label="Contact Fax">
              <input
                type="text"
                class="form-control"
                v-model="organisation.contact_fax"
              />
            </form-group>

            <form-group label="Email">
              <input
                type="email"
                class="form-control"
                v-model="organisation.email_address"
              />
            </form-group>

            

            <form-group label="Website">
              <input
                type="text"
                class="form-control"
                v-model="organisation.website"
              />
            </form-group>

            <form-group label="Physical Address" :required="true">
              <textarea-autosize
                @blur="$v.organisation.physical_address.$touch"
                :class="{ 'is-invalid': $v.organisation.physical_address.$error }"
                class="form-control"
                v-model="organisation.physical_address"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.organisation.physical_address.required"
              >
                enter address
              </div>
            </form-group>

            <form-group label="Postal Address">
              <textarea-autosize
                class="form-control"
                v-model="organisation.postal_address"
              />
            </form-group>

            <form-group label="Banking Details">
              <textarea-autosize
                class="form-control"
                v-model="organisation.banking_details"
              />
            </form-group>



          </template>
        </form-base>
      </div>
    </b-row>
  </div>
</template>

<script>
import organisationRepo from "@/api/repos/organisationRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup
  },

  validations: {
    organisation: {
      name: {
        required,
      },
      physical_address: {
        required,
      },
     
    },
  },

  mounted() {

  },


  data() {
    return {
      organisation: {
      },
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await organisationRepo.create(this.organisation);
         this.$root.$bvToast.toast('Organisation Created', {
            title: 'Success',
            autoHideDelay: 3000,
            variant: 'success',
          })
          this.$router.push({ name: 'organisations'})
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
            })
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;         
        }
      }
    },
  },
};
</script>
